import styled from 'styled-components';
export const AcceptedApplicationsContainer = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `${theme.spacing.md}px ${theme.spacing.lg}px`};
  gap: ${({ theme }) => theme.spacing.md}px;
  align-items: center;
`;
